import React from "react";
import useContactForm from "../../hooks/useContactForm";
import Loader from "../../components/Loader";

export default function ContactUsRightColumnForm() {
  const {
    form,
    loading,
    feedback,
    validationErrors,
    handleChange,
    handleBlur,
    handleSubmit,
    fieldRefs,
  } = useContactForm();

  const isFormValid =
    form.name.trim() && form.phone.trim() && form.message.trim();

  return (
    <form
      onSubmit={handleSubmit}
      className="space-y-6 border rounded-xl p-4 md:p-8 shadow-xl bg-white bg-opacity-90 backdrop-blur-sm"
      aria-label="Contact Us Form"
    >
      {/* Name Field */}
      <div className="flex flex-col">
        <label htmlFor="name" className="font-semibold text-gray-700">
          Name<span className="text-red-500">*</span>
        </label>
        <input
          ref={fieldRefs.name}
          id="name"
          type="text"
          name="name"
          placeholder="Your Name"
          value={form.name}
          onChange={handleChange}
          onBlur={handleBlur}
          aria-invalid={!!validationErrors.name}
          aria-describedby={validationErrors.name ? "name-error" : undefined}
          className={`w-full border rounded px-4 py-3 focus:ring focus:outline-none ${
            validationErrors.name ? "border-red-600" : "border-gray-300"
          }`}
        />
        {validationErrors.name && (
          <p id="name-error" className="text-red-600 text-sm mt-1" role="alert">
            {validationErrors.name}
          </p>
        )}
      </div>

      {/* Phone Field */}
      <div className="flex flex-col">
        <label htmlFor="phone" className="font-semibold text-gray-700">
          Phone<span className="text-red-500">*</span>
        </label>
        <p className="text-sm text-gray-400 mb-1">
          Mobile: 09876543211 <br />
          Landline: 08012345678
        </p>
        <input
          ref={fieldRefs.phone}
          id="phone"
          type="tel"
          name="phone"
          placeholder="Your phone number"
          value={form.phone}
          onChange={handleChange}
          onBlur={handleBlur}
          aria-invalid={!!validationErrors.phone}
          aria-describedby={validationErrors.phone ? "phone-error" : undefined}
          className={`w-full border rounded px-4 py-3 focus:ring focus:outline-none ${
            validationErrors.phone ? "border-red-600" : "border-gray-300"
          }`}
        />
        {validationErrors.phone && (
          <p id="phone-error" className="text-red-600 text-sm mt-1" role="alert">
            {validationErrors.phone}
          </p>
        )}
      </div>

      {/* Email Field */}
      <div className="flex flex-col">
        <label htmlFor="email" className="font-semibold text-gray-700">
          Email (optional)
        </label>
        <input
          ref={fieldRefs.email}
          id="email"
          type="email"
          name="email"
          placeholder="Your Email"
          value={form.email}
          onChange={handleChange}
          onBlur={handleBlur}
          aria-invalid={!!validationErrors.email}
          aria-describedby={validationErrors.email ? "email-error" : undefined}
          className={`w-full border rounded px-4 py-3 focus:ring focus:outline-none ${
            validationErrors.email ? "border-red-600" : "border-gray-300"
          }`}
        />
        {validationErrors.email && (
          <p id="email-error" className="text-red-600 text-sm mt-1" role="alert">
            {validationErrors.email}
          </p>
        )}
      </div>

      {/* Message Field */}
      <div className="flex flex-col">
        <label htmlFor="message" className="font-semibold text-gray-700">
          Message<span className="text-red-500">*</span>
        </label>
        <textarea
          ref={fieldRefs.message}
          id="message"
          name="message"
          rows="5"
          placeholder="Your Message"
          value={form.message}
          onChange={handleChange}
          onBlur={handleBlur}
          aria-invalid={!!validationErrors.message}
          aria-describedby={validationErrors.message ? "message-error" : undefined}
          className={`w-full border rounded px-4 py-3 resize-none focus:ring focus:outline-none ${
            validationErrors.message ? "border-red-600" : "border-gray-300"
          }`}
        />
        {validationErrors.message && (
          <p id="message-error" className="text-red-600 text-sm mt-1" role="alert">
            {validationErrors.message}
          </p>
        )}
      </div>

      {/* Feedback Message */}
      {feedback && (
        <div
          className={`p-3 rounded ${
            feedback.type === "success"
              ? "bg-green-200 text-green-800"
              : "bg-red-200 text-red-800"
          }`}
          role="status"
          aria-live="polite"
        >
          {feedback.message}
        </div>
      )}

      {/* Submit Button */}
      <button
        type="submit"
        disabled={!isFormValid || loading}
        className={`bg-sky-600 hover:bg-sky-700 text-white px-6 py-3 rounded-lg font-semibold w-full shadow transition ${
          !isFormValid || loading ? "opacity-60 cursor-not-allowed" : ""
        }`}
      >
        {loading ? (
          <>
            <Loader />
            <span>Sending...</span>
          </>
        ) : (
          "Send Message"
        )}
      </button>
    </form>
  );
}
